import React, { Component } from "react";
import Header from '../../layouts/Header';
import Footer from '../../layouts/Footer';
import { Tutions_Banner } from '../../components/Home/Banner';
import { BASE_URL, MAXDIS_FIL, MAXFEE_FIL, MINDIS_FIL, MINFEE_FIL, FIL_DIS, FIL_FEE, MAXFEE_FILP, MAXDIS_FILP, MAXFEE_FILPlay1, CENTERLAT, CENTERLNG } from '../../constant';
import FetchCall, { getAreaNames, getTutionList, getSchoolListDatas, tuitionFilter, saveLead, verifyOTP, getPhonenumber } from '../../API/FetchCall';
import { Link } from 'react-router-dom';
import { AdsOne, AdsTwo, AdsHorizandal, AdsVertical } from '../../components/others/ads';
import Rating from 'react-star-rating-component';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete';
import Geocode from "react-geocode";
Geocode.setApiKey("AIzaSyA9MtbfG_zlo64B2lqNMvigTBuXHkagKcE");
Geocode.setLanguage("en");
Geocode.setRegion("es");
Geocode.enableDebug();

import { TuitionRight } from '../../components/others/ads_vertical_landing';
import { TopTrending } from '../Banner/topTrending';
import $ from 'jquery';
import {
  Form,
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  CardText,
  CardFooter
} from "reactstrap";

import Step1PreSchool from "./Step1PreSchool";
import Step2PreSchool from "./Step2PreSchool";
import Step3PreSchool from "./Step3PreSchool";

import styled from "styled-components";
import MultiStepProgressBar from "./MultiStepProgressBar";

class LeadPreSchoolForm extends Component {
  constructor(props) {
    super(props);

    // Set the intiial input values
    this.state = {
      currentStep: 1,
      mobverified:0,
      listing:[],
      status:false,
      showForm:true,
      waiting:false,
      iscall:false,
      islisting:false,
      locationerros:false,
      isothers:false,
      email: "",
      city:"",
      Lastname: "",
      Firstname: "",
      Mobilenumber:"",
      location:"",
      searchkey:"",
      lat:0,
      lng:0,
      accepttakingcalls:"no",
      lead_vertical: "preschools",
      value: '',
      suggestions: [],
      latitude:'',
      longtitude:'',
      localities:[],
      isSuggested:false
    };
    //$(".invisible-content").hide();
    // Bind the submission to handleChange()
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleStatus = this.handleStatus.bind(this);
    this.handleChangeLocation = this.handleChangeLocation.bind(this);
    // Bind new functions for next and previous
    this._next = this._next.bind(this);
    this._prev = this._prev.bind(this);
  }

  // Use the submitted data to set the state
  handleChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value
    });

    if(value=='others'){
      this.setState({isothers:true})
    }else{
      this.setState({isothers:false})
    }    
  }

  componentDidMount() {

    const { history, location } = this.props;

    let data_auth = (localStorage.getItem("myData"));
    if (data_auth) {
        let auth_data = JSON.parse(data_auth)

        this.setState({
          l_first_name: auth_data.first_name,
          l_last_name: auth_data.last_name,
          l_email_id: auth_data.email_id,
       });

      //get phonenumberr
      this.getUserInfo(auth_data.user_id);
    }

    if(location.state!=undefined){

      this.setState({ 
          currentStep: location.state.step,
          location: location.state.location,
          latitude: location.state.latitude,
          longtitude: location.state.longtitude,
          isSuggested: location.state.isSuggested,
          city: location.state.city
       });

    }


  }
  

  getUserInfo(user_id){

    let userdata = JSON.stringify({
      user_id: user_id     
    })

    getPhonenumber(userdata).then((response) => {
        if (response.status == 1) {
          console.log(response);
          this.setState({email:response.email_id, 
               Lastname:response.last_name,
               Firstname:response.first_name, 
               Mobilenumber:response.phonenumber, 
               mobverified:response.isuserverified
          });
        }
    });

  }
  
  addjquery= () => {
      //alert("fddfdf");
      //var moreLessButton = $(".invisible-content").hasClass('hidden') ? 'Read Less' : 'Read More';
      //$('.btnreadmore').text(moreLessButton);
      $(".large-content").toggleClass('large-content-full');
          
  }
  handleStatus(status) {
    this.setState({
      mobverified: status
    });
  }

  handleChangeLocation(event) {
    
    const { name, value } = event.target;
    this.setState({
        [name]: value
    });

    Geocode.fromAddress(value).then(
    response => {
        if(response.status=='OK'){
          this.setState({locationerros:false, lat: response.results[0].geometry.location.lat, lng: response.results[0].geometry.location.lng });
        }
    },error => {
        this.setState({locationerros:true});
    });    
  
  }

  verifyOTPsent = (event) => {
      
      event.preventDefault();

      $("#Otp").removeClass('invalid').removeClass('valid');

      $("#verifiedstatus").removeClass('greentext').removeClass('redtext');
      $("#verifiedstatus").html('please wait....');

      let leaddata = JSON.stringify({
        mobilenumber: $("#countrycode").val()+$("#Mobilenumber").val(),
        otp: $("#Otp").val(),
      })

      verifyOTP(leaddata).then((response) => {
          if (response.status==1) {
              $("#Otp").addClass('valid');
              this.setState({mobverified:1});
              $("#verifiedstatus").addClass('greentext').html('Success, your mobile number is verified.');
          }
          else if (response.status==2) {
              $("#Otp").addClass('invalid');
              this.setState({mobverified:0});
              $(".sendoptbutton").show().html('Resend OTP');
              $("#verifiedstatus").addClass('redtext').html('OTP is invalid.');
          }
          else{
              $("#verifiedstatus").html('Issue verifying OTP.');
          }
      }); 

  }

  handleSubmit = (event) => {

      event.preventDefault();

      if(this.state.Firstname==''){
        alert("please enter first name");
        return false;
      }

      if(this.state.Lastname==''){
        alert("please enter last name");
        return false;
      }

      if(this.state.Mobilenumber==''){
        alert("please enter mobile number");
        return false;
      }
      
      let toastr = '';
      const { 
          email, 
          Lastname, 
          Firstname, 
          Mobilenumber, 
          searchkey, 
          location,
          latitude,
          longtitude,
          city, 
          lead_classfrequency,
          lead_premisestype,
          lead_preschooltype,
          lead_mode,
          accepttakingcalls
       } = this.state;

      let leaddata = JSON.stringify({
        email: email,
        Firstname: Firstname,
        Lastname: Lastname,
        Mobilenumber: Mobilenumber,
        searchkey:searchkey,
        city:city,
        lat:latitude,
        lng:longtitude,
        location: location,
        lead_vertical: 'preschools',
        lead_classfrequency: lead_classfrequency,
        lead_premisestype: lead_premisestype,
        lead_preschooltype: lead_preschooltype,
        lead_mode: lead_mode,
        accepttakingcalls:accepttakingcalls
      })

      this.setState({showForm:false, waiting:true, status:false});

      saveLead(leaddata).then((response) => {

          if (response.status == 1) {
                      
              this.setState({waiting:false, status:true, listing:response.result});
         
          }
        
      }); 
  
  };

  // Trigger an alert on form submission
  handleSubmit2 = event => {
    event.preventDefault();
    const { email, Lastname, Firstname } = this.state;
    alert(`Your registration detail: \n 
      Email: ${email} \n 
      Lastname: ${Lastname} \n
      Firstname: ${Firstname}`);
  };

  // Test current step with ternary
  // _next and _previous functions will be called on button click
  _next() {
    let currentStep = this.state.currentStep;

    if(currentStep==1 && this.state.city==''){
      alert("please select city");
      return false;
    }

    if(currentStep==1 && this.state.location==''){
      alert("please enter locality");
      return false;
    } 

    if(currentStep==1 && this.state.locationerros){
      alert("please verify locality you entered is valid");
      return false;
    }
    
    if(currentStep==2 && this.state.searchkey==''){
      alert("please choose Type");
      return false;
    }

    let isSuggested = this.state.isSuggested;
    if(!isSuggested){
      alert("Invalid Locality..please choose any one of suggested localities");
      return false;
    }    

    // If the current step is 1 or 2, then add one on "next" button click
    currentStep = currentStep >= 2 ? 3 : currentStep + 1;
    this.setState({
      currentStep: currentStep
    });
  }

  _prev() {
    let currentStep = this.state.currentStep;
    // If the current step is 2 or 3, then subtract one on "previous" button click
    currentStep = currentStep <= 1 ? 1 : currentStep - 1;
    this.setState({
      currentStep: currentStep
    });
  }

  // The "next" and "previous" button functions
  get previousButton() {
    let currentStep = this.state.currentStep;

    // If the current step is not 1, then render the "previous" button
    if (currentStep !== 1) {
      return (
        <Button color="secondary btn-sm float-left" onClick={this._prev}>
          Previous
        </Button>
      );
    }

    // ...else return nothing
    return null;
  }

  get nextButton() {
    let currentStep = this.state.currentStep;
    // If the current step is not 3, then render the "next" button
    if (currentStep < 3) {
      return (
        <Button color="primary btn-sm float-right" onClick={this._next}>
          Next
        </Button>
      );
    }
    // ...else render nothing
    return null;
  }

  get submitButton() {
    let currentStep = this.state.currentStep;
    let mobverified = this.state.mobverified;
    // If the current step is the last step, then render the "submit" button
    if (currentStep > 2 && mobverified==1) {
      return <Button color="primary btn-sm float-right">Submit</Button>;
    }
    // ...else render nothing
    return null;
  }

 escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
  onSuggestionsFetchRequested = ({ value }) => {

    const val = this.escapeRegexCharacters(value.trim());
    let fetch = JSON.stringify({
      city: this.state.city,
      keyword:val
    });
    getAreaNames(fetch).then(res => {
      if (res.status == 1) {
        this.setState({
          suggestions: res.list
        });
      }
    });
  };

  onSuggestionSelected = (event, { suggestion, suggestionValue, index, method }) => {
      console.log('ping... ', suggestion)

      this.setState({
          latitude: suggestion.latitude,
          longtitude: suggestion.longtitude,
          isSuggested:true
      });


  }

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };
  getSuggestionValue = (suggestion) => {
    return suggestion.name;
  }

  renderSuggestion(suggestion) {
    return (
      <span>{suggestion.name}</span>
    );
  }

  onAutoSuggestChange = (event, { newValue, method }) => {
    this.setState({
      location: newValue,
      isSuggested:false
    });
  };


  render() {

    let topTrending = {
      category_id: 2,
      city: 'bengaluru',
      subcategory: 17,
      subcategory_term: 'montessori',
      category_name: 'pre-schools',
      sub_category: 0
    }

    const {value, suggestions, city, isothers, localities} = this.state;


    const inputPropsD = {
      value: this.state.location,
      onChange: this.onAutoSuggestChange,
      name: 'location',
      className: 'form-control'
    };        

    return (
      <React.Fragment>
        <Header />

        <section class="secound-landing features-area nav nav-tabs new-landing-page" id="nav-tab" role="tablist">
          <div className='container'>
            <div class="row" style={{ padding: 10 }}>

              <div className="mt-3 col-lg-3 col-md-4 pl-md-0 d-none d-md-block">
                  <div className='laning-stick'>
                       <div className="d-none d-md-block">
                        <TopTrending param={topTrending} />
                      </div>

                  </div>
              </div>
              <div className="mt-3 col-lg-8 col-md-8 leadform">
                      {this.state.showForm && !this.state.waiting && !this.state.status && (
                      <div class="formdisplay">
                      <Form onSubmit={this.handleSubmit}>
                        <Card>
                          <CardHeader>Find Best Of Preschools in Bengaluru</CardHeader>
                          <CardBody>
                            <CardTitle>
                              <MultiStepProgressBar currentStep={this.state.currentStep} />
                            </CardTitle>
                            <CardText />
                            <Step1PreSchool
                              currentStep={this.state.currentStep}
                              handleChange={this.handleChange}
                              city={this.state.city}  
                              location={this.state.location}  
                              isothers={isothers}
                              suggestions={suggestions}
                              onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                              onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                              getSuggestionValue={this.getSuggestionValue}
                              renderSuggestion={this.renderSuggestion}
                              onSuggestionSelected={this.onSuggestionSelected}
                              inputPropsD={inputPropsD}
                            />
                            <Step2PreSchool
                              currentStep={this.state.currentStep}
                              handleChange={this.handleChange}

                            />
                            <Step3PreSchool
                              currentStep={this.state.currentStep}
                              handleChange={this.handleChange}
                              verifyOTPsent={this.verifyOTPsent}
                              email={this.state.email} 
                              Lastname ={this.state.Lastname} 
                              Firstname ={this.state.Firstname} 
                              Mobilenumber ={this.state.Mobilenumber} 
                              mobverified ={this.state.mobverified} 
                              
                            />
                           
                          </CardBody>
                          <CardFooter>
                            {this.previousButton}
                            {this.nextButton}
                            {this.submitButton}
                          </CardFooter>
                        </Card>
                      </Form>
                      </div>
                      )}
                      {this.state.waiting && !this.state.status && (
                      <div class="waiting">
                        
                            processing...please wait.... 

                      </div>
                       )}
                      
                      {!this.state.nolisting && this.state.iscall && !this.state.waiting && this.state.status && (
                      <div class="aftersubmitdisplay fade-in-image">
                      
                        <div class="alert alert-success" role="alert">
                          <h4 class="alert-heading">Well done!</h4>
                          <p>Your information is processed successfully. We will reach you soon</p>
                          <hr/>
                          <p class="mb-0">You have successfully registered @BeWise portal, Please <a href="/email-verification">click here</a> to verify and login.</p>
                        </div>

                                          
                    </div>
                      )}

                   
                   {this.state.listing.length>0 && 
                      <div class="col-lg-12 col-md-12">
                        <div class="alert alert-success" role="alert">
                        <div class="msg_black">
                            <p>Please find list of schools as per your selection. <br/> 
                            For your convenience, a mail with Top 5 from this short list has been sent to your mail box. <br/> 
                            (FYI - We are enabling follow through calls to you - from institutions of your choice) <br/> </p>
                          </div>
                        </div>
                      </div>
                    }


                  {!this.state.waiting && this.state.status && (
                      <div class="listing-lead">
                        
                        <h5>Search results: </h5>

                        {this.state.listing.length>0 && 

                         this.state.listing.map((item, idx) => (   
                      <div class="col-lg-12 col-md-12">

                      <React.Fragment>
                        <div class="row">
                         <div className='col-xs-12 col-md-12'>
                          <div className='row landing-tile'>
                            <div className='col-xs-12 col-lg-12'>
                              <div className='row align-items-center d-flex'>
                                
                                <div className='col-3 pr-0 '>
                                  <div className='tile-img'>
                                    <img src={item.images} />
                                  </div>
                                </div>
                                
                                <div className='col-9'>
                                        <div className='tile-detail-sec tile-title row align-items-center'>
                                         <div className='col-lg-10 p-0'>
                                            <p className='text-wrap'>
                                             <a href={item.partner_link} target="_blank">{item.name}</a>
                                            </p>
                                          </div>
                                          <div className='col-lg-2 p-0 d-none d-md-block'>
                                            <div className='tile-btn-biew pull-right'>
                                               <a href={item.partner_link} target="_blank" className='btn btn-sm btn-primary'>More Info</a>
                                              
                                            </div>
                                          </div>
                                          
                                        </div>
                                        <div className='tile-detail-sec tile-adrs row'>
                                          <p className='text-wrap'>{item.address}</p>
                                        </div>
                                        <div className='tile-detail-sec align-items-center row'>

                                        </div>
                                        
                                      </div>
                                
                              </div>
                            </div>
                            
                          </div>
                        </div>
                      </div> 

                      </React.Fragment>

                      </div>


                          ))
                      
                       }
                      {this.state.listing.length>0 && 
                      <React.Fragment>
                      <div class="row">
                        <span class="endline">If you want to see more listing, please&nbsp;<a href={'/' + this.state.city + '/pre-schools/montessori'}>click here</a></span>
                      </div>
                      </React.Fragment>
                      }

                       {this.state.listing.length==0 &&
                        <div class="listing-lead listing_nodata">Sorry, We have no data found at this time.
                        </div>
                       }



                      </div>


                      )}


                      {this.state.status && (
                      <div class="backoptions">
                            <p><i class="fas fa-info-circle"> Click on an option below for any other info</i></p>
                               
                            <a href="/best-tuitions-near-me" class="btn btn-primary btn-sm">Tuitions</a>
                            &nbsp;
                            <a href="/best-schools-near-me" class="btn btn-primary btn-sm">School</a>
                            &nbsp;

                            <a href="/best-sports-classes-near-me" class="btn btn-primary btn-sm">Sports</a>
                            &nbsp;
                             <a href="/best-music-classes-near-me" class="btn btn-primary btn-sm">Music</a>
                            &nbsp;
                             <a href="/best-dance-classes-near-me" class="btn btn-primary btn-sm">Dance</a>
                            &nbsp;
                            <a href="/best-arts-classes-near-me" class="btn btn-primary btn-sm">Creative Arts</a>
                            &nbsp;
                            <a href="/best-skill-enrichment-classes-near-me" class="btn btn-primary btn-sm">Mind and Skill enrichment</a>
                            &nbsp;
                            <a href="/best-hobby-passion-enriching-classes-near-me" class="btn btn-primary btn-sm">Hobbies and Passion</a>
                            &nbsp;
                            <a href="/best-preschools-near-me" class="btn btn-primary btn-sm"><i class="fas fa-refresh">Reload</i></a>
                            &nbsp;
                      </div>
                      )}


                      <div class="large-content">

                     <div class="visible-content">
                          <h5>How to choose the best Preschool near me?</h5>
                          <p>Selecting the right Preschool for our children can be a challenge. What is the most suitable one? Depending on parents' preferences, preschools are evaluated differently by each parent. Be sure to ask yourself "what type of preschool and which location are best for my child" before making any decisions. How you begin determines how you end. Parents are therefore keen to send their children to top pre-schools near by the school for this reason. A pre-school or the Montessori schools near your school is the first place where a child learns. 
Important points to remember while choosing Montessori Schools for your child!</p>
                     </div> 

                     <div class="invisible-content">

                     <h5>Distance</h5>
<p> Always consider the distance of the preschool from your location. You should always try to choose preschool near me location, because as a parent you will never expect your little baby travels long distance spending hours and getting tired. So, always try to choose for the preschool nearby your location. Always search on Google with search terms which help to get nearby location preschool like best preschool near me, or best Montessori schools near my location. Also you can visit our portal BeWise where, you can search the preschool near me location but also compare other facilities with the all other Montessori schools or day-care present in that same near locality and can choose the best option for your little one.</p>
<h5>Credibility </h5>
<p>Even if the parents found the preschool near to their house still there is lots of check remaining, one of them is the best infrastructure, being a Parent one must check the review of that preschool nearby your location with other parents or through various online portals like BeWise. Always check credibility of the school? Try to visit the all the Montessori schools nearby location and check for the in charge of that preschool and how the management works. Do these preschools have proper infrastructure and educational facilities for small kids schooling and day-care? Always check the website and social media link of these Preschool to get better idea.</p>
<h5>Teaching methods followed in Indian Play School near me location</h5>

<p>The curriculum in various preschools may vary. So, before taking kindergarten admission for your child, always check the curriculum and syllabus that is followed the by the preschool you choose. Therefore, always check and talk to the pre-school management or coordinators to find out what all activities (Fine and Gross motor skill development, Public speaking, Phonics etc.) are covered in their preschool or not. There are many different methods used in Indian preschools near me location. The most popular ones are Kindergarten, Montessori, and Play school. Some other pedagogy are evolving and gaining popularity in recent times, viz, Reggio Emilia, Waldorf Steiner, Multiple Intelligence, Bank Street. Some Play schools use a combination of two or methods to impart knowledge and train pre-schoolers. </p>
<h5>Faculty</h5>
<p>The best play schools near your location should have teachers who are experienced, patient and exude love. In kindergarten teacher are the second mothers who will be responsible and taking care of the well-being of your little one. So, while choosing a any Montessori/play school, parents must visit the school and meet the faculty.  This way a parent can find out about the teachers experience of handling small kids.</p> 
<p>BeWise offers easy and intuitive support to help the parent / child make the best suited decisions. We have an option where parents can search, compare and select their tuition classes near by the location.</p>


                    </div>

                    
                    </div>

            
                     

                     
              </div>

              <div className="mt-3 col-md-1 pl-md-2 m-hide-ads">
                <div className='laning-stick'>
                  <TuitionRight />
                </div>
              </div>
            </div>
            <AdsHorizandal />
          </div>
        </section>
      <Footer />
      </React.Fragment>
    );
  }
}

export default LeadPreSchoolForm;
